"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledAuxDiv = exports.StyleUserOptions = exports.StylePin = exports.StyleMenuHeader = exports.StyleLogo = exports.StyleClose = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
var _default = exports.default = _styledComponents.default.nav.withConfig({
  componentId: "sc-1goqctk-0"
})(["background-color:", ";color:", ";padding:8px 8px 48px 16px;position:fixed;left:-100%;width:100%;top:0;bottom:0;overflow-y:scroll;z-index:999;", " @media ", "{padding:16px 0px 48px 2px;position:fixed;min-width:", ";max-width:", ";min-height:100%;left:0;overflow-y:scroll;overflow-x:hidden;&:hover{min-width:220px;max-width:220px;}::-webkit-scrollbar{width:0px;}::-webkit-scrollbar-thumb:hover{background:", ";}}-webkit-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;"], (0, _color.default)('gray'), (0, _color.default)('white'), _ref => {
  let {
    opened
  } = _ref;
  return opened && "\n        left: 0;\n    ";
}, _responsive.default.lg, _ref2 => {
  let {
    pinnedMenu
  } = _ref2;
  return pinnedMenu ? '220px' : '48px';
}, _ref3 => {
  let {
    pinnedMenu
  } = _ref3;
  return pinnedMenu ? '220px' : '48px';
}, (0, _color.default)('gray-2'));
const StyleUserOptions = exports.StyleUserOptions = _styledComponents.default.div.withConfig({
  displayName: "StyleUserOptions",
  componentId: "sc-1goqctk-1"
})(["margin:0;@media ", "{display:none;}"], _responsive.default.lg);
const StyleMenuHeader = exports.StyleMenuHeader = _styledComponents.default.div.withConfig({
  displayName: "StyleMenuHeader",
  componentId: "sc-1goqctk-2"
})(["display:flex;justify-content:space-between;align-items:center;@media ", "{padding:0px 4px;margin-bottom:16px;}"], _responsive.default.lg);
const StyleLogo = exports.StyleLogo = _styledComponents.default.div.withConfig({
  displayName: "StyleLogo",
  componentId: "sc-1goqctk-3"
})(["display:flex;align-items:center;justify-content:center;width:100%;height:32px;margin:8px 12px 16px 4px;background-image:url('/assets/img/brands/cockpit-white.svg');background-repeat:no-repeat;-webkit-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;@media ", "{width:100%;height:", ";background-image:url(", ");margin:0px 4px;}"], _responsive.default.lg, _ref4 => {
  let {
    pinnedMenu,
    showPin
  } = _ref4;
  return pinnedMenu || showPin ? '36px' : '24px';
}, _ref5 => {
  let {
    pinnedMenu,
    showPin
  } = _ref5;
  return "/assets/img/brands/cockpit-".concat(pinnedMenu || showPin ? 'white' : 'icon-small', ".svg");
});
const StylePin = exports.StylePin = _styledComponents.default.div.withConfig({
  displayName: "StylePin",
  componentId: "sc-1goqctk-4"
})(["display:none;@media ", "{cursor:pointer;display:", ";height:24px;width:24px;background-image:url(", ");background-repeat:no-repeat;-webkit-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;margin-right:8px;&:before{position:fixed;display:none;content:'';margin-left:24px;background-color:", ";padding:4px 8px;border-radius:4px;color:", ";font-size:10px;font-style:normal;font-weight:500;line-height:130%;}&:hover{&:before{content:\"", "\";display:block;}}}"], _responsive.default.lg, _ref6 => {
  let {
    showPin
  } = _ref6;
  return showPin ? 'block' : 'none';
}, _ref7 => {
  let {
    pinnedMenu
  } = _ref7;
  return "/assets/img/icons/".concat(pinnedMenu ? '' : 'un', "pinned-menu.svg");
}, (0, _color.default)('gray-2'), (0, _color.default)('white'), _ref8 => {
  let {
    pinnedMenu
  } = _ref8;
  return pinnedMenu ? 'Desfixar menu' : 'Fixar menu';
});
const StyleClose = exports.StyleClose = _styledComponents.default.div.withConfig({
  displayName: "StyleClose",
  componentId: "sc-1goqctk-5"
})(["width:24px;height:24px;display:block;background-image:url('/assets/img/icons/close-2-white.svg');background-repeat:no-repeat;background-size:cover;-webkit-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;margin:0px 12px 8px 0px;@media ", "{display:none;}"], _responsive.default.lg);
const StyledAuxDiv = exports.StyledAuxDiv = _styledComponents.default.div.withConfig({
  displayName: "StyledAuxDiv",
  componentId: "sc-1goqctk-6"
})(["display:none;width:", ";-webkit-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;@media ", "{display:block;}"], _ref9 => {
  let {
    pinnedMenu
  } = _ref9;
  return pinnedMenu ? '220px' : '48px';
}, _responsive.default.lg);